import { FormControl } from '@angular/forms';

export function validateEmail(c: FormControl) {
    let EMAIL_REGEX = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]){2,4}$/;

    // If the value of the control tests against the regex, there is no error (return null).
    return (c.value == null || c.value == '' || EMAIL_REGEX.test(c.value) ? null : {
        validateEmail: {
            valid: false
        }
    });
}


// WEBPACK FOOTER //
// ./src/validators/email.validator.ts